import { recursoLegivel } from '@/modulos/cadastros/trilha';

/**
 * A linha do tempo da maquina em palavras do sistema — a ficha da mesa e a do
 * celular (M09) leem DAQUI, e o doctor (H10) confere que o nome da tabela do
 * banco nunca chega a tela.
 */

/**
 * A trilha guarda `insert`/`update`/`delete`; a tela fala portugues de obra.
 *
 * O VOCABULARIO E FECHADO, e o `else` NAO devolve mais o identificador cru.
 * A versao anterior traduzia tres recursos e caia em `recurso` para todo o
 * resto — e como o modulo 08 e a fronteira do 03 escrevem na mesma trilha com
 * `equipamento_id`, a ficha de qualquer maquina ja exibia "Registro de
 * comb.abastecimento" e "Registro de oper.leitura_medidor" para quem opera.
 * Nome de tabela do banco nao e palavra do sistema; o manual nao tem lugar
 * para ele.
 *
 * TODA TABELA AUDITADA QUE CARREGA A MAQUINA tem nome aqui (prova do marco do
 * ciclo 1, 07/10/2026): a ficha mostrava "Registro de um registro do sistema"
 * para a O.S., o turno, a inspeção — oito nomes cobriam uma trilha que já tinha
 * trinta tabelas com `equipamento_id`. O teste (`trilha.test.ts`) lê as
 * migrações e reprova a tabela nova sem nome. O que escapar ainda sai pelo
 * nome legível da trilha da governança, nunca pelo `schema.tabela`.
 */
export const NOME_DO_RECURSO: Readonly<Record<string, string>> = {
  'ativos.alocacao': 'alocação',
  'ativos.situacao': 'situação',
  'ativos.equipamento': 'ficha do equipamento',
  'ativos.foto_do_equipamento': 'foto do equipamento',
  'ativos.depreciacao_do_equipamento': 'depreciação da máquina',
  'ativos.filial_da_obra_atual': 'filial da obra atual',
  'comb.abastecimento': 'abastecimento',
  'comb.aplicacao_lubrificante': 'aplicação de lubrificante',
  'comb.ordem_abastecimento': 'ordem de abastecimento',
  'comb.folha_de_campo': 'folha de campo do abastecimento',
  'estoq.movimento': 'movimento de estoque',
  'insp.inspecao': 'inspeção',
  'insp.ocorrencia': 'ocorrência de inspeção',
  'manut.plano': 'plano de manutenção',
  'manut.realizacao': 'manutenção realizada',
  'oficina.ordem': 'O.S.',
  'oper.leitura_medidor': 'leitura de medidor',
  'oper.apontamento': 'apontamento de horas',
  'oper.pacote_levado': 'saída do pacote para a obra',
  'oper.divergencia': 'divergência de horas',
  'oper.folha_de_turno': 'folha de turno',
  'oper.hora_reconhecida': 'hora reconhecida pelo cliente',
  'oper.linha_importada': 'linha de horas importada',
  'org.maquina_do_piloto': 'entrada no piloto',
  'pess.documento': 'documento da máquina',
  'rec.item_da_medicao': 'item da medição de contrato',
  'rec.regra_do_contrato': 'regra de valor do contrato',
  'tecnico.aplicacao': 'aplicação de documento técnico',
  'tecnico.caso_de_avaliacao': 'caso de avaliação da IA',
  'tecnico.pergunta': 'pergunta ao manual',
  /* 0103: a telemetria — o dispositivo na máquina, a mensagem e o resumo do dia. */
  'telem.vinculo': 'dispositivo de telemetria na máquina',
  'telem.mensagem': 'mensagem da telemetria',
  'telem.resumo_do_dia': 'resumo do dia da telemetria',
  /* 0106: a linha do orçamento que nomeia a máquina (módulo 19). */
  'orc.linha': 'linha do orçamento',
  'estrat.estudo': 'estudo de renovação',
  'estrat.proposta': 'proposta de investimento',
  /* 0109: a marca de candidata levada ao aviso. */
  'estrat.candidata_observada': 'marca de candidata à renovação',
  /* 0105: a previsão e a proposta técnica da preditiva (módulo 18). */
  'manut.previsao': 'previsão de falha',
  'manut.proposta_tecnica': 'proposta técnica',
};

export function descreverAcao(acao: string, recurso: string): string {
  const oque = NOME_DO_RECURSO[recurso] ?? recursoLegivel(recurso).toLocaleLowerCase('pt-BR');

  switch (acao) {
    case 'insert':
      return `Registro de ${oque}`;
    case 'update':
      return `Alteração de ${oque}`;
    case 'delete':
      return `Exclusão de ${oque}`;
    case 'ler':
      return `Consulta à ${oque}`;
    default:
      return `${acao} · ${oque}`;
  }
}
